import {Specialization} from '@/types'
import apiClient from '@/utils/axios'
import {AxiosResponse} from 'axios'

interface SpecializationService{
  getAllSpecialization: () => Promise<AxiosResponse<Specialization[]>>
}

const specialization: SpecializationService = {
  async getAllSpecialization(): Promise<AxiosResponse<Specialization[]>> {
    const response = await apiClient.get('/specializations')
    return response
  },
}

export {specialization}
